<template>
  <div class="f-events" v-show="areEventsPresent">
    <h2 class="title-container clickable" @click="loadEvents">{{activeLanguage.events}}</h2>
    <div class="post-container">
      <div class="post-container" v-masonry transition-duration="0.3s" item-selector=".item"  :fit-width="true">
        <div v-masonry-tile class="item" v-for="(event, index) in events" :key="index"
             :class="[{'card-mobile': $store.getters.isMobileValue}]">
          <event-card :post-content="event"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EventsPage from '../eventsPageComponents/EventsPage'
  import EventCard from '../../utilComponents/EventCard'

  export default {
    name: 'Events',
    components: {EventCard},
    data () {
      return {
        events: []
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      areEventsPresent () {
        return this.events.length > 0
      }
    },
    methods: {
      loadEvents () {
        this.$store.commit('setCurrentView', EventsPage)
        this.$router.push('/events')
      },
      fetchMostRecentEvents () {
        let self = this
        this.$http.get(this.$PATH_NAME + 'events/getHighlights/').then((response) => {
          self.events = response.body
        })
      }
    },
    mounted () {
      this.fetchMostRecentEvents()
    }
  }
</script>

<style scoped>

  .f-events {
    /*background-color: whitesmoke;*/
    border-radius: 8px;
    height: 100%;
    padding: 3% 0 0;
  }

  .card-mobile > a > div {
    max-width: 500px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/Events.vue